// @ts-check

import { api } from '@/api'
import { init as initSentry } from '@/core/sentry'
import { i18n } from '@/i18n'
import { router } from '@/router'
import { store } from '@/store'
import { vuetify } from '@/vuetify/setup'
import { createPinia } from 'pinia'
import VueViewer from 'v-viewer'

import '@/styles/main.css'
import 'viewerjs/dist/viewer.css'

import { createApp } from 'vue'

import { createSentryPiniaPlugin } from '@sentry/vue'

import App from './App.vue'

const app = createApp(App)

app.config.globalProperties.$api = api

app.use(vuetify)
app.use(router)
app.use(createPinia().use(createSentryPiniaPlugin()))
app.use(store)
app.use(i18n)
app.use(VueViewer)

initSentry(app)

// @FIXME: This should not be manually assigned since adding i18n plugin already
// does this, however, there is an unresolved issue where the translation method
// is not available after router.push() so this fixes it for now
app.config.globalProperties.$t = i18n.global.t

app.mount('#app')

if (window && window.Cypress) {
  app.$store = store
  window.app = app
}
